import { PaletteOptions } from "@mui/material";

export interface Colors {
  white: string;
  primaryGreen: string;
  warning: string;
  lightGreen: string;
  magnetite: string;
  defaultTextColor: string;
  greenText: string;
  obsidian: string;
  gray: string;
  orange: string;
  lightRed: string;
}

export const colors: Colors = {
  white: "#ffffff",
  primaryGreen: "#00833E",
  warning: "#BD0202",
  lightGreen: "#e4f5ec",
  magnetite: "rgba(248,248,248,0.82)",
  defaultTextColor: "#353535",
  greenText: "#1F8E42",
  obsidian: "#000000",
  gray: "#F5F7FB",
  orange: "rgba(245, 106, 11, 0.12)",
  lightRed: "#fee8e8",
};

export const palette: PaletteOptions = {
  primary: {
    main: colors.primaryGreen,
  },
  error: {
    main: colors.warning,
  },
  secondary: {
    main: colors.white,
  },
};
